<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Contact Us</title>
</head>
<body>
  <section class="contact-us">
    <div class="blinking-text">
      <p style="font-size: 35px; font-weight: bold; color: #7AE2CF; text-align: center;">
        <img src="../../assets/img/icon/LOGO.png" height="70px" width="70px" alt="PARASAKTHI SCHOOL">&nbsp;PARASAKTHI SCHOOL
      </p>      
    
    </div>
  </section>

  <div class="row1">
    <div class="col-lg-6 text-center w3-animate-left" style="padding-right: 0px;">
        <div class="contact-detail">
            <img src="../../assets/img/contact/bgcontactus.jpg" alt="Notebook" class="contact-img text-center">
            <div class="content p-4">
                <br /><br />
                <h1 class="text-light align-middle" style="color: white;">LOCATION</h1>
                <h4 class="align-middlefont-weight-bold">PARASAKTHI SCHOOL
                    <sup >
                        <i class="fa fa-registered" aria-hidden="true"></i>
                    </sup>
                    
                </h4>
                <p class="align-middle">
                 Sri Parasakthi vidyalaya- CBSE,
                    <br />
                   Courtallanathar road
                    <br />
             Courtallam.627 802.TamilNadu
                </p>
            
                <h1 class="text-light">Phone | E-mail </h1>
                <p>
                  <span class="fa fa-phone" style="color: #ffffff; font-size: 25px;" aria-hidden="true"><a class="mail-call" href="tel:04633 212993">&nbsp;&nbsp;&nbsp;&nbsp;04633 283133</a></span>
                    <br />
                    <span class="fa fa-phone" style="color: #ffffff; font-size: 25px;" aria-hidden="true"><a class="mail-call" href="tel:8122983133" target="_blank">&nbsp;&nbsp;8122983133</a></span>
                    <br />
                    For General Enquiries: 
                    <a class="mail-call" href="mailto:sriparasakthividyala@yahoo.co.in">sriparasakthividyala@yahoo.co.in</a>
                    <br /><br>
                    <br />
                </p>
                
        </div>
    </div>
</div>
</div>
<br><br>
</body>
</html>

    <div class="container-fluid animatable bounceIn">
       <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3941.4117661949895!2d77.27654097501772!3d8.934149691123435!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zOMKwNTYnMDIuOSJOIDc3wrAxNic0NC44IkU!5e0!3m2!1sen!2sin!4v1749035514706!5m2!1sen!2sin" width="100%" height="300" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>

  <div class="text-center d-flex justify-content-center align-items-center flex-wrap mt-4">
  <a href="tel:04633 283133">
    <span class="fa fa-phone" style="background: linear-gradient(#077A7D , #7AE2CF); color: white; font-size: 20px; padding: 10px; border-radius: 5px;"></span>
  </a>&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; 
  <a href="mailto:sriparasakthividyala@yahoo.co.in">
    <span class="fa fa-envelope" style="background: linear-gradient(#077A7D, #7AE2CF); color: white; font-size: 20px; padding: 10px; border-radius: 5px;"></span>
  </a> &nbsp; &nbsp;&nbsp;&nbsp;&nbsp; 
  <a href="https://wa.me/8122983133" target="_blank">
    <i class="fa fa-whatsapp" style="background: linear-gradient(#077A7D, #7AE2CF); color: white; font-size: 20px; padding: 10px; border-radius: 5px;"></i>
  </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>


 